import { useNavigate } from 'react-router-dom'
import AppCard from 'ui/AppCard'

const SettingsManagmentList = () => {
	const navigate = useNavigate()

	return (
		<AppCard
			title='Управление пользователями'
			description='Создавайте и редактируйте пользователей.'
			onClick={() => navigate('/settings/management')}
		/>
	)
}

export default SettingsManagmentList
